import WidgetExecutionEnvironment from '@/enums/WidgetExecutionEnvironment';

export default {
  isWidgetEnvironmentShop({ widgetEnv }) {
    return widgetEnv === WidgetExecutionEnvironment.SHOP;
  },
  isReviewOptionSelected({ reviewOptions }) {
    return Object.keys(reviewOptions).length !== 0;
  },
  isProductOptionSelected({ productOptions }) {
    return Object.keys(productOptions).length !== 0;
  },
  hasSelectedFilters({ categoryId, scores, query }, getters) {
    return (
      !!categoryId ||
      scores?.length > 0 ||
      !!query ||
      getters.isReviewOptionSelected ||
      getters.isProductOptionSelected
    );
  },
  widgetUrl: ({ brandCode }, _getters, { session }) => (path, params = {}) => {
    const normalizedPath = path.replace(/^\/+/, '');
    const query = new URLSearchParams({
      ...session.sessionParams,
      ...params
    }).toString();
    return `${window.location.origin}/v2/${brandCode}/${normalizedPath}${
      query ? `?${query}` : ''
    }`;
  },
  fromTargetWidget: ({ cohortItemId, expiresSince, expiresUntil }) =>
    !!cohortItemId && !expiresSince && !expiresUntil,
  cremaDomainPrefix: ({ env }) =>
    env === 'production' ? '' : window.location.host[0]
};
